import * as React from "react";
import {createElement} from "react";
import {render} from "@variocube/app-ui";
import {App} from "./components/App";
import {BarcodeBrowserInit} from "./barcode";

render(<App />);

BarcodeBrowserInit();